import React from "react";
import PluginBridge from "../index";

/**
 * Slot de botoes ao lado do input de mensagem do chat.
 *
 * Plugins declaram actions com `slot: "message-input"` no metadata.
 * Aceita resultTypes: insert-text, dialog, text, html, json.
 *
 * `wrap={false}`: este é o ponto dos BOTÕES. O mesmo slot tem outro ponto, no
 * MessageInput, que envolve a caixa de digitação e é onde o controlador
 * imperativo deve montar (é ele que o notificamehub esconde quando a janela de
 * 24h expira). Sem isto, o controlador montaria duas vezes.
 *
 * Props:
 *   ticketId      — id do ticket ativo
 *   contactId     — id do contato do ticket
 *   channel       — canal do ticket (usado para filtrar actions por canal)
 *   whatsappId    — id da conexão do ticket
 *   draft         — texto já digitado na caixa (para ações sobre o rascunho)
 *   onInsertText  — callback para inserir texto no input (resultType: "insert-text")
 */
export default function MessageInputSlot({ ticketId, contactId, channel, whatsappId, draft, onInsertText }) {
  // Sem wrapper posicionado de propósito: a sugestão de IA (#4328) sobe com
  // `bottom: 100%` e deve se ancorar na barra inteira (`newMessageBox`, que é
  // `position: relative`). Um wrapper relativo AQUI a prenderia à largura do
  // botão — o balão virava uma vareta.
  return (
    <PluginBridge
      slot="message-input"
      as="buttons"
      wrap={false}
      // `draft`: o que já está digitado. Há ação que trabalha sobre ele
      // (corrigir, traduzir) e não sobre a conversa.
      context={{ ticketId, contactId, channel, whatsappId, draft }}
      onInsertText={onInsertText}
    />
  );
}
